import React from 'react';

// Components
import { WpModal, WpModalBody, WpModalHeader, WpModalFooter } from 'Wpds/components/modal';
import { WpButton } from 'Wpds/components/button';

// Styles
import './JoinWaitlistSuccessModal.scss';

type Props = {
  isOpen: boolean;
  toggleIsOpen: () => void;
};

const JoinWaitlistSuccessModal = ({ isOpen, toggleIsOpen }: Props) => {
  const baseClassName = 'JoinWaitlistSuccessModal';

  return (
    <WpModal isOpen={isOpen} onToggle={toggleIsOpen} size="sm" innerClassName={baseClassName} dismissOnBackdrop={false}>
      <WpModalHeader>You’ve been added to the waitlist!</WpModalHeader>
      <WpModalBody>
        <div className={`${baseClassName}__img-wrapper`}>
          <img
            src="https://piprodperformassets.blob.core.windows.net/assets/charma_clipboard.png"
            className={`${baseClassName}__img-wrapper__img`}
          />
        </div>
        You’re on the waitlist! You’ll get an email when it’s time for you to join the beta!{' '}
      </WpModalBody>
      <WpModalFooter>
        <WpButton onClick={toggleIsOpen}>Done</WpButton>
      </WpModalFooter>
    </WpModal>
  );
};

export default JoinWaitlistSuccessModal;
